// eslint-disable-next-line import/no-default-export -- deprecated usage
export { default } from "./Button";
export type { ButtonProps } from "./Button";
